import React from "react";
import styles from "./SearchBar.module.css";

const SearchBar = React.memo(function ({
  keywordSearch = () => {},
  placeholder = "카테고리명을 입력해주세요",
  onClick = () => {},
  value = "",
  isInput = true,
}) {
  const clearValue = (e) => {
    e.stopPropagation();
    keywordSearch({ target: { value: "" } });
  };
  return (
    <div className={styles.searchBar}>
      <div className={styles.searchContainer} onClick={onClick}>
        <div className={styles.iconArea}>
          <div className={styles.searchIcon} />
        </div>
        {!!value && (
          <input
            className={styles.inputArea}
            placeholder={placeholder}
            value={value}
            onKeyUp={(e) => {
              keywordSearch(e);
            }}
            readOnly={!isInput}
            onClick={onClick}
          />
        )}
        {!value && (
          <input
            className={styles.inputArea}
            placeholder={placeholder}
            onKeyUp={(e) => {
              keywordSearch(e);
            }}
            readOnly={!isInput}
            onClick={onClick}
          />
        )}
        {!!value && (
          <div
            className={styles.cancel}
            onClick={(e) => {
              clearValue(e);
            }}
          >
            X
          </div>
        )}
      </div>
    </div>
  );
});

export default SearchBar;
